import { EnvironmentService } from 'src/app/singleton-services/environment.service'
import { InjectionToken } from '@angular/core'

export const WINDOW = new InjectionToken<Window>('FLO.WINDOW')

// global server-side injections
export function globalInitialInjections(es: EnvironmentService, nrClient?: any) {
  return []
}
